import gsap from "gsap";
import { enablePageScroll, disablePageScroll, clearQueueScrollLocks } from "scroll-lock";

disablePageScroll();

function loadingPage() {
  const loading = $(".loading");
  if (localStorage.getItem('loading') !== undefined && localStorage.getItem('loading') !== 'false') {
    gsap
      .fromTo(
        loading,
        0.5,
        { opacity: "1", zIndex: "999999" },
        { opacity: "0", zIndex: "-1", onComplete: () => {
          loading.remove();
          localStorage.setItem('loading', 'false');
        }}
      )
      .delay(2);
  } else {
    loading.remove();
  }
}
loadingPage();

function preLoadingPage() {
  const preloading = $(".preloading");
    gsap
      .fromTo(
        preloading,
        0.5,
        { opacity: "1", zIndex: "99999" },
        { opacity: "0", zIndex: "-1", onComplete: () => {
          preloading.remove();
          enablePageScroll();
        }}
      )
      .delay(1);
}
preLoadingPage();